export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "bmk-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "bmk-themeWrapLive" */'./LiveThemeImporter'),
  },
};
